// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file device/device_errors.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file device/device_errors.proto.
 */
export const file_device_device_errors: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChpkZXZpY2UvZGV2aWNlX2Vycm9ycy5wcm90bxIUY29tLmdlbS5iZmYuY29udHJhY3QiIAoLRGV2aWNlRXJyb3IaEQoPRGV2aWNlSXNCbG9ja2VkQhgKFGNvbS5nZW0uYmZmLmNvbnRyYWN0UAFiBnByb3RvMw'
  );

/**
 * @generated from message com.gem.bff.contract.DeviceError
 */
export type DeviceError = Message<'com.gem.bff.contract.DeviceError'> & {};

/**
 * Describes the message com.gem.bff.contract.DeviceError.
 * Use `create(DeviceErrorSchema)` to create a new message.
 */
export const DeviceErrorSchema: GenMessage<DeviceError> =
  /*@__PURE__*/
  messageDesc(file_device_device_errors, 0);

/**
 * E_DEVICE_BLOCKED
 *
 * @generated from message com.gem.bff.contract.DeviceError.DeviceIsBlocked
 */
export type DeviceError_DeviceIsBlocked =
  Message<'com.gem.bff.contract.DeviceError.DeviceIsBlocked'> & {};

/**
 * Describes the message com.gem.bff.contract.DeviceError.DeviceIsBlocked.
 * Use `create(DeviceError_DeviceIsBlockedSchema)` to create a new message.
 */
export const DeviceError_DeviceIsBlockedSchema: GenMessage<DeviceError_DeviceIsBlocked> =
  /*@__PURE__*/
  messageDesc(file_device_device_errors, 0, 0);
